"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var HiddenRadio = _styledComponents["default"].input.attrs({
  type: "radio"
}).withConfig({
  displayName: "Radio__HiddenRadio",
  componentId: "sc-1ennuez-0"
})(["", " &:focus ~ div > div:first-child{background-color:", ";}"], (0, _polished.hideVisually)(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[5];
});

var Wrapper = _styledComponents["default"].label.withConfig({
  displayName: "Radio__Wrapper",
  componentId: "sc-1ennuez-1"
})(["opacity:", ";cursor:", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 0.6 : 1;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? "not-allowed" : "auto";
});

var LabelWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Radio__LabelWrapper",
  componentId: "sc-1ennuez-2"
})(["user-select:none;"]);

var CustomRadio = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Radio__CustomRadio",
  componentId: "sc-1ennuez-3"
})(["width:20px;height:20px;transition:0.18s;flex-shrink:0;&:hover{background-color:", ";}"], function (_ref4) {
  var theme = _ref4.theme,
      isSelected = _ref4.isSelected;
  return isSelected ? "none" : theme.colors.dark[5];
});

var Radio = function Radio(_ref5) {
  var id = _ref5.id,
      disabled = _ref5.disabled,
      Label = _ref5.label,
      colour = _ref5.colour,
      onChange = _ref5.onChange,
      checked = _ref5.checked,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, ["id", "disabled", "label", "colour", "onChange", "checked"]);

  var _useState = (0, _react.useState)(checked),
      isSelected = _useState[0],
      setIsSelected = _useState[1];

  var handleChange = function handleChange(e) {
    setIsSelected(e.target.value);
    onChange(e);
  };

  return _react["default"].createElement(Wrapper, {
    disabled: disabled
  }, _react["default"].createElement(HiddenRadio, (0, _extends2["default"])({
    id: id,
    defaultChecked: checked,
    disabled: disabled,
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }, props)), _react["default"].createElement(_Flex["default"], {
    alignItems: "center",
    flexDirection: "row"
  }, _react["default"].createElement(CustomRadio, {
    isSelected: isSelected,
    mr: 3,
    border: "2px solid",
    borderColor: colour,
    borderRadius: 99,
    justifyContent: "center",
    alignItems: "center"
  }, checked && _react["default"].createElement(_Flex["default"], {
    width: "10px",
    height: "10px",
    bg: checked ? colour : "transparent",
    borderRadius: "50%"
  })), Label && _react["default"].createElement(LabelWrapper, null, _react["default"].createElement(Label, null))));
};

Radio.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string, _propTypes["default"].func]),
  id: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  colour: _propTypes["default"].string,
  checked: _propTypes["default"].bool
};
Radio.defaultProps = {
  label: function label() {
    return null;
  },
  disabled: false,
  checked: false,
  colour: "primary.0"
};
var _default = Radio;
exports["default"] = _default;